'use strict';

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearFormErrors(form) {
    $(form).find('.form-control.is-invalid').removeClass('is-invalid');
}

/**
 * Initialize realtime validation for postal code fields (digits only).
 * @param {element} $form - Form or container with postal code input
 * @returns {void}
 */
function initOnKeypressValidation($form, selector, pattern, cleanRegex) {
    // prevent invalid characters
    $form.find(selector).on('keypress', function(e) {
        if (e.which !== 0 && !pattern.test(String.fromCharCode(e.which))) {
            e.preventDefault();
        }
    });
    
    // clear the complete value when blur the field
    $form.find(selector).on('focusout', function() {
        var cleanValue = $(this).val().replace(cleanRegex, '');
        if ($(this).val() !== cleanValue) {
            $(this).val(cleanValue).trigger('input');
        }
    });
}


module.exports = function (formElement, payload) {
    // clear form validation first
    clearFormErrors(formElement);
    $('.alert', formElement).remove();
    if (typeof payload === 'object' && payload.fields) {
        Object.keys(payload.fields).forEach(function (key) {
            if (payload.fields[key]) {
                var feedbackElement = $(formElement).find('[name="' + key + '"]')
                    .parent()
                    .children('.invalid-feedback');

                if (feedbackElement.length > 0) {
                    if (Array.isArray(payload[key])) {
                        feedbackElement.html(payload.fields[key].join('<br/>'));
                    } else {
                        feedbackElement.html(payload.fields[key]);
                    }
                    feedbackElement.siblings('.form-control').addClass('is-invalid');
                }
            }
        });
    }

    if (payload && payload.error) {
        var form = $(formElement).prop('tagName') === 'FORM'
            ? $(formElement)
            : $(formElement).parents('form');

        if(form.data('error-container')) {
            const alert = $(`
                <div class="alert alert-danger" role="alert">
                    <img src=${form.data('alert-icon-url')} alt=${form.data('alert-icon-alt')}/>
                    ${payload.error.join('<br/>')}
                </div>
            `);
            
            const errorContainer = form.find(form.data('error-container'));
            errorContainer.append(alert);
        }
        else {
            form.prepend('<div class="alert alert-danger" role="alert">'
                + payload.error.join('<br/>') + '</div>');
        }
    }
};

module.exports.initOnKeypressValidation = initOnKeypressValidation;